module.exports = __webpack_public_path__ + "static/media/IMG_0264.14421ff2.JPG";